import PrettyBytes from './components/PrettyBytes';

export default PrettyBytes;
